import { FaRegMoneyBillAlt } from "react-icons/fa";
import colors from "core/resources/theme/colors";
import DashboardCard from "ui/components/Cards/DashboardCard";
import { useTotalReceitas } from "core/features/dashboards/hooks/useTotalReceitas";
import { useDashboardPrincipal } from "core/features/dashboards/store";
import { formatMoney } from "infra/helpers/number";

function CardReceitas() {
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useTotalReceitas(query);

  return (
    <DashboardCard
      isLoading={isFetching}
      positive={true}
      bg={colors.lightGray}
      label="Contas Recebidas"
      valuePercent={null}
      value={formatMoney(data?.total ?? 0)}
      icon={<FaRegMoneyBillAlt fontSize="32px" color={colors.darkGray} />}
    />
  );
}

export default CardReceitas;
